import Splide from '@splidejs/splide';
import '@splidejs/splide/css';

/**
 * Initializes carousels for lift blocks.
 */
function initCarousels() {
	const liftCarousels = document.querySelectorAll('.lifts.carousel');

	liftCarousels.forEach((carousel) => {
		const splide = new Splide(carousel, {
			type: 'loop',
			perPage: 1,
			perMove: 1,
			arrows: true,
			pagination: false,
			autoplay: true,
			interval: 5000,
			speed: 1000,
			gap: '30px',
		});

		splide.mount();
	});
}

document.addEventListener('DOMContentLoaded', () => {
	initCarousels();

	if (window.acf) {
		window.acf.addAction('render_block_preview/type=nostokortti', initCarousels);
	}
});
